<template>
  <Navigation/>
  <div class="order">
    <table class="orderBlock">
      <h3 class="formTitle">库库会员订单</h3>
      <tbody>
        <tr>
          <td class="first_td">用户账号：</td>
          <td>{{ info.user_id }}</td>
        </tr>
        <tr>
          <td class="first_td">订单号：</td>
          <td>{{ info.order_sn }}</td>
        </tr>
        <tr>
          <td class="first_td">交易金额：</td>
          <td>{{ info.order_amount }}</td>
        </tr>
        <tr>
          <td class="first_td">支付方式：</td>
          <td>{{ formattedPayType }}</td>
        </tr>
        <tr>
          <td class="first_td">支付状态：</td>
          <td>{{ formattedPayStatus }}</td>
        </tr>
        <tr>
          <td class="first_td">支付时间：</td>
          <td>{{ formattedPayTime }}</td>
        </tr>
        <tr>
          <td class="first_td">会员有效期：</td>
          <td>{{ this.userInfo.vipExpire }}</td>
        </tr>
      </tbody>
    </table>
    <h2 class="pay_message">您的订单已支付成功，请重新登录或重启3ds max 启用会员加速服务</h2>
  </div>
</template>

<script>
import Navigation from '@/components/Navigation.vue'
import axios from 'axios';

export default {
  name: 'Oeder',
  components: {
    Navigation: Navigation
  },

  data: function(){
    return {
        info:'',
        userInfo: '',
    };
  },

  computed: {
    formattedPayTime() {
      if (!this.info.pay_time) return '';
      
      const date = new Date(this.info.pay_time);
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      }).replace(/\//g, '年')
        .replace(/(\d+)年(\d+)/, '$1年$2月')
        .replace(/(\d+)月(\d+)/, '$1月$2日');
    },

    formattedPayStatus(){      
      if (!this.info.pay_status) return '';      
      const status = this.info.pay_status;
      if (status == 'TRADE_SUCCESS' || status == 'TRADE_FINISHED'){
        return '支付成功'
      }
      else{
        return '未支付'
      }
    },

    formattedPayType(){      
      if (!this.info.pay_type) return '';      
      const pay_type = this.info.pay_type;
      if (pay_type == 'ALIPAY'){
        return '支付宝'
      }
      else if(pay_type == 'WEIXINPAY'){
        return '微信支付'
      }
      else{
        return '其他方式支付'
      }
    },
  },

  mounted(){
    this.getOrderInfo()
  },

  methods: {
    async getOrderInfo() {
      try {
        const outTradeNo = this.$route.query.out_trade_no;
        if (!outTradeNo) {
          console.error('未找到订单号');
          return;
        }
        
        const response = await axios.get('/api/order/' + outTradeNo);
        this.info = response.data;
        
        if (this.info && this.info.user_id) {
          await this.getUserInfo();
        } else {
          console.error('订单信息中缺少user_id');
        }
        
      } catch (error) {
        console.error('获取订单信息失败:', error);
      }
    },
    
    async getUserInfo() {
      try {
        if (!this.info || !this.info.user_id) {
          console.error('用户ID不存在，无法获取用户信息');
          return;
        }
        
        const response = await axios.get('/api/user/' + this.info.user_id);
        this.userInfo = response.data;
        
      } catch (error) {
        console.error('获取用户信息失败:', error);
      }
    }
  },
}
</script>

<style>

.order{
    width: fit-content;
    margin: 128px auto;
    background-color: rgb(250, 250, 250);
    box-shadow: 0 0 24px rgba(0, 0, 0, 0.1);
    border-radius: 18px;
    padding: 64px 96px;
}

.order *{
  user-select: none;
}

.formTitle{
  color: white;
  padding: 4px 48px;
  background-color: #45B5B5;
  clip-path: polygon(0 0, calc(100% - 25px) 0, 100% 25px, 100% 100%, 0 100%);
}

.order table{
  margin: 0 auto;
  table-layout: auto;
  border-collapse: collapse;
  border: none;
  width: auto;
  width: min-content;
  min-width: min-content;
}

.order td{
  color: gray;
  padding: 14px 96px;
  border-bottom: 1px solid #45B5B5;
  white-space: nowrap;
}

.order tr:first-child td {
  border-top: 1px solid #45B5B5;
}

.order tr:last-child td {
  border-bottom: 1px solid #45B5B5;
}

.first_td{
  padding: 14px 36px;
  text-align: right;
}

.pay_message{
  text-align: center;
  color: #45B5B5;
  margin: 0 auto;
  line-height: 72px;
}

</style>